import { useQuery } from '@tanstack/react-query'
import { usersControllerGetUserInfo } from 'api.gen'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'

interface SelectClassEligibility {
  shouldRenderSelectClass: boolean
  currentEntityName: string | null
}

const fetchSelectClassEligibility =
  async (): Promise<SelectClassEligibility> => {
    const response = await usersControllerGetUserInfo()

    if (response.status === 200) {
      const { data } = response
      const isReader = data.teacher_id === null && data.reader_id !== null

      return {
        shouldRenderSelectClass: isReader && data.multiple_entities,
        currentEntityName: data.entity_name ?? null
      }
    }

    return { shouldRenderSelectClass: false, currentEntityName: null }
  }

export const useSelectClassEligibility = () => {
  const { featureToggles, isLoadingFeatureTogglesData } = useFeatureToggles()
  const hasMultipleClassesFlag = Boolean(featureToggles?.multipleClasses)

  const { data } = useQuery({
    queryKey: ['select-class-eligibility'],
    queryFn: fetchSelectClassEligibility,
    enabled: hasMultipleClassesFlag
  })

  return {
    shouldRenderSelectClass:
      hasMultipleClassesFlag && (data?.shouldRenderSelectClass ?? false),
    currentEntityName: data?.currentEntityName ?? null,
    isLoading: isLoadingFeatureTogglesData
  }
}
